/* eslint-disable import/no-cycle */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { InfoCircle } from 'tabler-icons-react';
import { Anchor } from '@mantine/core';
import { Link } from 'react-router-dom';
import AppStack from '../../../../common/AppStack';
import AppText from '../../../../common/AppText';
import AppCard from '../../../../common/AppCard';
import AppFlexbox from '../../../../common/AppFlexbox';
import ProductCareInstructionsModal from '../../ProductCareInstructionsModal';

const WsCheckoutCareInstructionsAlert = ({
  ecomStoreCartProducts,
  mediaQueries,
  baseStoreUrl,
  onNavigate,
  isDrawerView,
  editModeEnabled
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isTabletOrSmaller } = mediaQueries;

  return (
    <>
      <AppCard
        radius={isTabletOrSmaller ? 0 : 'md'}
        shadow="xs"
        style={{ padding: 0 }}
        withBorder
      >
        <AppFlexbox
          style={{
            padding: 8,
            gap: 8,
            backgroundColor: '#5A8CA8',
            color: '#fff',
            alignItems: 'center'
          }}
        >
          <AppStack>
            <InfoCircle size={24} />
          </AppStack>
          <AppText style={{ fontSize: 16, fontWeight: 500 }}>
            Care Tips for Your Products
          </AppText>
        </AppFlexbox>
        <AppStack style={{ padding: 8, gap: 8 }}>
          <AppText style={{ fontSize: 14 }}>
            Keep your items looking their best! Review our{' '}
            <Anchor
              onClick={() => {
                setIsModalOpen(true);
              }}
              style={{ fontSize: 14, color: 'dodgerblue' }}
            >
              care instructions
            </Anchor>{' '}
            to protect your designs and make them last longer.
          </AppText>
          <AppFlexbox>
            <Anchor
              component={Link}
              onClick={onNavigate}
              style={{ fontSize: 14, color: 'dodgerblue' }}
              to={`${baseStoreUrl}/about/care-instructions`}
            >
              View all care instructions
            </Anchor>
          </AppFlexbox>
        </AppStack>
      </AppCard>

      <ProductCareInstructionsModal
        baseStoreUrl={baseStoreUrl}
        ecomStoreCartProducts={ecomStoreCartProducts}
        editModeEnabled={editModeEnabled}
        isOpen={isModalOpen}
        mediaQueries={mediaQueries}
        onClose={() => setIsModalOpen(false)}
        onNavigate={onNavigate}
      />
    </>
  );
};

WsCheckoutCareInstructionsAlert.propTypes = {
  baseStoreUrl: PropTypes.string,
  ecomStoreCartProducts: PropTypes.array,
  editModeEnabled: PropTypes.bool,
  isDrawerView: PropTypes.bool,
  mediaQueries: PropTypes.object,
  onNavigate: PropTypes.func
};

export default WsCheckoutCareInstructionsAlert;
